import React from 'react';

interface FormButtonProps {
    caption: string;
    onClick: () => void;
    disabled?: boolean;
}

const FormButton: React.FC<FormButtonProps> = ({ caption, onClick, disabled = false }) => (
    <button
        className={`font-bold py-2 px-4 rounded ${
            disabled 
                ? 'bg-gray-400 text-gray-700 cursor-not-allowed' 
                : 'bg-blue-500 hover:bg-blue-700 text-white'
        }`}
        onClick={onClick}
        disabled={disabled}
    >
        {caption}
    </button>
);

export default FormButton;